// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2269a270","977":"a1d0610d"}[chunkId] + ".chunk.js";
};